var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-regex/node_modules/has/src/index.js
// module id = 1105
// module chunks = 58